module.exports = __webpack_public_path__ + "front/img/yqh_foot01.aab396d7.png";